import { ENTITLEMENT_DATA } from '../../../../constants';

export const initialState = {
  isEntitlementsLoading: false,
  selectededTab: 0,
  isMainScreen: false,
  isAddNew: false,
  loading: false,
  errors: {}, // You can store the form errors here
  isActiveLoading: false, // You can store the active loading here
  isDeactiveLoading: false, // You can store the deactive loading here
  isResultsFound: false, // variable for result found here
  isEntitlementsSiteActivityResultsFound: false, // variable for result found here
  errorModal: null, // variable for error modal here
  noDataFound: false, // variable for no data found here
  alertDialog: false, // variable for alert dialog here
  alertText: ENTITLEMENT_DATA.errorMsg, // variable for alert text here
  apiSuccessResponse: {
    activate: false,
    deactivate: false,
    create: false,
    update: false,
  }, // You can store the api success response here

  //Entitlements SiteActivity Data
  entitlementsSiteActivityData: [], // You can store the entitlements Shipping Info data here
  entitlementsSiteActivityTotalRecords: 0,

  entitlementsSiteActivitySelectedRow: [], // You can store the entitlements Site Activity selected row here

  //User Details
  user: '',
  userId: 0,
  siteActivityRunning: false,
  SAJobData: [],
  SAJobRun: false,
  reqSiteId: 0,
  jobRunReqTransfer: {
    Site_Id: 0,
    Site_Activity_Type_Id: 5, //1 for Deactivate
    Activity_Date: '',
    Entitlement_Site_List: '', //eid + activity date combo separated by |
    Invoice_Number: '', //from response
    Dest_Site_Id: 0, //need to map to dest site id
    Entitlement_Upgrade_List: '', //need from vaibhav
    Entitlement_Install_List: '', //null always
    SiteActivityId: 0, //from api response
    Disassemble: false, //false for activate
    Waiting: false, //false for activate
    User_Id: 0, //current userid
  },
};
